import {HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ListRequest} from '../../../../interfaces/list-request.interface';
import {BaseApiClient} from '../../../../shared/api-clients/base-api-client';
import {BASE_SITE, OCC_BASE_PATH} from '../../../../shared/constants/api';
import {addComparisonParams} from '../../../../shared/utils/http-param.utils';
import {
  AllInquiryResponse,
  CreateGeneralInquiry,
  CreateOrderInquiry,
  CustomerSalesRepresentativeInfo,
  InquiryDetailResponse,
} from '../interface/inquiry.interface';

@Injectable({
  providedIn: 'root',
})
export class InquiryApiClient extends BaseApiClient {
  override getBaseRawUrl(): string {
    return `${OCC_BASE_PATH}${BASE_SITE}/inquiry`;
  }

  override getBaseBinaryUrl(): string {
    return `${OCC_BASE_PATH}${BASE_SITE}/inquiry`;
  }

  public getCsrInformation(): Observable<CustomerSalesRepresentativeInfo[]> {
    return this.client.get<CustomerSalesRepresentativeInfo[]>(`${this.rawApi}/csr`);
  }

  public createOrderInquiry(data: CreateOrderInquiry): Observable<void> {
    const formData = new FormData();

    // Append data as JSON blob object
    const jsonBlob = new Blob([JSON.stringify(data)], {type: 'application/json'});
    formData.append('orderInquiryCreationWsDTO', jsonBlob);

    // Append files to the FormData
    data.files?.forEach((file) => {
      formData.append('attachments', file, file.name);
    });

    return this.client.post<void>(`${this.rawApi}/create/order`, formData);
  }

  public createGeneralInquiry(data: CreateGeneralInquiry): Observable<void> {
    return this.client.post<void>(`${this.rawApi}/create/general`, data);
  }

  public getAllInquiries(request: ListRequest): Observable<AllInquiryResponse> {
    return this.client.post<AllInquiryResponse>(
      `${this.rawApi}/list`,
      {filters: request.filters},
      {params: this.buildHttpParams(request)},
    );
  }

  public getInquiryDetail(ticketId: string): Observable<InquiryDetailResponse> {
    return this.client.get<InquiryDetailResponse>(`${this.rawApi}/${ticketId}`);
  }

  private buildHttpParams(request: ListRequest): HttpParams {
    let params = new HttpParams()
      .set('pageSize', request.pageSize?.toString())
      .set('currentPage', request.currentPage?.toString());

    if (request.sort) {
      params = params.append('sort', request.sort?.toString() ?? '');
    }

    if (request.sortDirection) {
      params = params.append('sortDirection', request.sortDirection ?? '');
    }

    const updatedFilter = request.filters?.find((filter) => filter.name === 'updated');

    if (updatedFilter) {
      params = addComparisonParams(params, updatedFilter);
    }

    return params;
  }

  public exportAttachment(
    url: string,
    name: string,
    mimeType: string,
    ticketId: string,
  ): Observable<Blob> {
    return this.client.get(`${this.binaryApi}/${ticketId}/attachment`, {
      params: new HttpParams().set('url', url).set('name', name).set('mimeType', mimeType),
      responseType: 'blob',
    });
  }
}
